<template>
    <Button v-if="canPOD" :label="$t('epod')" icon="pi pi-check-circle" class="p-button-warning p-button-sm mr-2" @click="onShowModal" />
    <!-- <Button v-if="canViewPOD" :label="$t('view_pod')" icon="pi pi-file" class="p-button-warning p-button-sm mr-2" @click="onShowModal" /> -->

    <CustomSidebar v-model:visible="showModal" position="bottom" :dismissable="false" :title="sidebarLabel" class="p-1" :blocked="blocked">
        <template #actions>
            <!-- <Button v-if="canPOD" icon="pi pi-save" class="p-button p-button-success mr-1" label="Save" @click="onSavePOD()"></Button> -->
            <Button icon="pi pi-save" class="p-button p-button-success mr-1" label="Save" @click="onSavePOD()"></Button>
        </template>

        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-4 md-4 p-fluid">
                <ScrollPanel style="width:100%;height:80vh">
                    <ModalDataShipment :data="shipmentData" v-if="shipmentData"/>
                </ScrollPanel>
            </div>
            <Divider layout="vertical" />
            <div class="col-8 md-4 p-fluid">
                <ScrollPanel style="width:100%;height: 80vh">
                    <FormField :labelName="$t('pod_notes')" fieldName="podNotes" v-model="shipmentData" fieldClass="col-6" labelClass="col-4">
                        <Textarea v-model="shipmentData.POD_Remarks" rows="3" cols="50" v-if="shipmentData" />
                    </FormField>

                    <FormField :labelName="$t('pod_upload_file')" fieldName="podFiles" v-model="shipmentData" fieldClass="col-6" labelClass="col-4">
                        <CustomFileUpload
                            :fileModels="viewPODFiles"
                            :multiple="true" 
                            :showUploadButton="false" 
                            :showCancelButton="false" 
                            :customUpload="false" 
                            @select="onFileSelect" 
                            @remove="onFileRemove" 
                            :viewOnly="true" 
                            :showHeader="false"
                            @download="onDownloadFile"
                            v-if="canViewPOD"
                            />
                    </FormField>

                    <FormField :labelName="''" fieldName="podFiles" v-model="shipmentData" fieldClass="col-6" labelClass="col-4">
                        <CustomFileUpload 
                            :multiple="true" 
                            :showUploadButton="false" 
                            :showCancelButton="false" 
                            :customUpload="false" 
                            @select="onFileSelect" 
                            @remove="onFileRemove" 
                            />
                    </FormField>

                    <Divider />    

                    <DataTable :loading="!shipmentData" :value="shipmentData ? shipmentData.Details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                        <Column field="Item_No" :header="$t('item_no')" key="Item_No">  
                        </Column>
                        <Column field="Material_Name" header="Material" key="Material_Name"  >
                        </Column>
                        <Column field="POD_Qty" :header="$t('receive_qty')" key="POD_Qty" style="width:15%">
                            <template #body="slotProps">
                                <div class="p-inputgroup">
                                    <InputNumber v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" :optionalDecimal="true"/>
                                    <span class="p-inputgroup-addon">{{slotProps.data['UOM']}}</span>
                                </div>
                                <div class="p-inputgroup" v-if="showAltUOM(slotProps.data['UOM'])">
                                    <InputNumber v-model="slotProps.data['POD_Qty1']" mode="decimal" :optionalDecimal="true"  />
                                    <span class="p-inputgroup-addon">PCS</span>
                                </div>
                            </template>
                        </Column>
                         <Column field="POD_Return_Qty" :header="$t('return_qty')" key="POD_Return_Qty" style="width:15%">
                            <template #body="slotProps">
                                <div class="p-inputgroup">
                                        <InputNumber v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" :optionalDecimal="true" /> <!-- :disabled="canViewPOD" -->
                                    <span class="p-inputgroup-addon">{{slotProps.data['UOM']}}</span>
                                </div>
                                <div class="p-inputgroup" v-if="showAltUOM(slotProps.data['UOM'])">
                                    <InputNumber v-model="slotProps.data['POD_Return_Qty1']" mode="decimal" :optionalDecimal="true" />
                                    <span class="p-inputgroup-addon">PCS</span>
                                </div>

                            </template>
                        </Column>
                        <Column field="Qty" :header="$t('delivery_qty')" key="Qty" style="width:15%">
                            <template #body="slotProps">
                                <div class="p-inputgroup">
                                        <InputText v-model="slotProps.data[slotProps.column.props.field]" :disabled="true"/>
                                    <span class="p-inputgroup-addon">{{slotProps.data['UOM']}}</span>
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </ScrollPanel>
            </div>
        </div>
    </CustomSidebar>  

</template>
<script>
    import ModalDataShipment from '../Helper/_ModalDataShipment.vue'

    export default{
        components: {
            'ModalDataShipment': ModalDataShipment,
        },
        emits:['close'],
        props:{
            data: {
                type: Object,
                default: null
            },
            mode:{
                type:String,
                default: ""
            },
            canPOD: {
                type:Boolean,
                default: false
            },
            canViewPOD:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return{
                showModal: false,
                isIndividual: false,
                isCollective: false,
                isRelation: false,
                driverModels: [],
                driversData: null,
                shipmentData: null,
                driverModel: null,
                dataUrl: "shipment/",
                blocked:false,
                podNotes: "",
                podFiles: [],
                viewPODFiles: null
            }
        },
        mounted(){
            
        },
        methods:{
            reset(){
                this.shipmentData = null;
                this.podNotes = "";
                this.podFiles = [];
                
            },
            onShowModal(){
                this.reset();
            
                this.blocked = true;
                this.showModal = true;

                var self = this;

                this.$axios.get(this.$API_URL + this.dataUrl + this.data.Id + "/" + this.$FORM_MODE_EDIT)
                    .then((response) => {
                        if (response.data.success) {
                            self.shipmentData = response.data.data.header;

                            if(self.canViewPOD){
                                self.viewPODFiles = [];

                                if(self.shipmentData.PODs.length > 0){
                                    for(var x = 0; x< self.shipmentData.PODs.length;x++){
                                        var pod = self.shipmentData.PODs[x];
                                        var fileData = {
                                            name: pod.File_Name,
                                            id: pod.Id
                                        };

                                        self.viewPODFiles.push(fileData);
                                    }
                                }


                            }

                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });

            },
            onDownloadFile(file){
                var self = this;
                this.$axios.get(this.$API_URL + this.dataUrl + "download_pod/" + file.id, {
                    responseType: 'blob'
                    })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file.name);
                        document.body.appendChild(link);
                        link.click();
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found", life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });
                
                
            },
            onSavePOD(){
                var self = this;

                var data = new FormData();

                data.append("shipment_id", this.data.Id);
                data.append("pod_remarks", this.shipmentData.POD_Remarks);

                for(var i=0; i< this.podFiles.length;i++){
                    data.append("file", this.podFiles[i], this.podFiles[i].name);
                }

                data.append("shipment_details", JSON.stringify(this.shipmentData.Details));

                self.blocked = true;

                this.$axios.put(this.$API_URL + this.dataUrl + "pod", data,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) =>{
                        if (response.data.success) {
                            self.$parent.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 120000});
                            self.showModal = false;
                             self.$emit("close");
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        self.blocked = false;
                       
                    }).catch((err) => {
                        console.log(err);
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 120000});
                        self.blocked = false;
                        self.showModal = false;
                    });
            },
            showAltUOM(uom){
                if(uom == "KG" || uom == "MT"){
                    return false;
                }
                else return true;
            },
            onFileSelect(event){
                this.podFiles = event.files;
            },
            onFileRemove(files){
                this.podFiles = files;
            }
        },
        computed:{
            sidebarLabel(){
                return this.canPOD ? this.$t('pod') : this.$t('view_epod');
            }
        }


    }

</script>